import { useSuspenseQuery } from '@tanstack/react-query';

import { getAwardValidationHistoryOptions } from '@/module/Author/Award/Validation/model/AwardValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface AwardValidationHistoryProps {
  awardId: Id;
}

export function AwardValidationHistory({ awardId }: AwardValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getAwardValidationHistoryOptions(awardId));

  return <ValidationHistoryContent history={history} />;
}
